import React, { useContext } from "react";
import { AuthContext } from "../../utils/auth-provider.js";
import { analytics } from '../../utils/firebase.js'
import { logEvent } from "@firebase/analytics";
import Loading from '../loading.js';
import AuthBox from '../auth-box.js';

export default function Login() {
    
    return (
        <AuthBox version="login" />
    )
}
